/**
 * @author Jensen<zhhnch@gmail.com>
 * @description
 * @since 2018/3/29
 */

import { Store } from 'vuex'

const gSetPermissions = 'gSetPermissions'

const plugin = {

  install (Vue, options) {
    if (options && options.store && options.store instanceof Store) {
      // do nothing
    } else {
      throw new Error('gRac required a vuex store instance.')
    }

    let { store } = options

    store.registerModule('gPermissions', {
      state: {
        permissions: []
      },
      getters: {},
      mutations: {
        [gSetPermissions] (state, permissions) {
          state.permissions = permissions
        }
      },
      actions: {
        [gSetPermissions] ({ commit }, payload) {
          commit(gSetPermissions, payload)
        }
      }
    })

    Vue.directive('gRac', (el, binding) => {
      const accessDenied = !binding.value
      const styleAttr = 'style'
      const hiddenStr = 'visibility:hidden;display:none !important'
      let styleStr = (el.getAttribute(styleAttr) || '').replace(hiddenStr, '')
      if (accessDenied) {
        styleStr += `;${hiddenStr}`
      }
      styleStr = styleStr.replace(/(^[;])|([;]$)/g, '')
      styleStr ? el.setAttribute(styleAttr, styleStr) : el.removeAttribute(styleAttr)
    })
  }
}

export default plugin
